/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-cycle */
import { all, fork } from 'redux-saga/effects';
import MintNFTsSaga from 'modules/mint-nfts/saga';
import GetNFTsSaga from 'modules/home/saga';
import PurchaseNFTsSaga from 'modules/artworks/saga';
import GetMyNFTsSaga from 'modules/my-artworks/saga';
import GetAdminsSaga from 'modules/admin/saga';
import AddAdminSaga from 'modules/add-admin/saga';
/**
 * Register all the saga functions into the root saga
 */
export default function* rootSaga() {
  yield all([
    fork(MintNFTsSaga),
    fork(GetNFTsSaga),
    fork(PurchaseNFTsSaga),
    fork(GetMyNFTsSaga),
    fork(GetAdminsSaga),
    fork(AddAdminSaga),
  ]);
}
